module.exports = __webpack_public_path__ + "static/media/stockhausen_haum_20.7500a6a3.jpg";